import ServerPagination from "../ServerPagination";
import StatusBadge from "../UI/StatusBadge";

const CountryPaymentGatewayTable = ({
    data = [],
    loading = false,
    pagination = {},
    onPageChange,
    onEdit,
    onDelete,
}) => {
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center gap-3 py-24">
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-emerald-600" />
                <p className="text-sm text-slate-500">Loading configurations...</p>
            </div>
        );
    }

    if (!loading && data.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center gap-3 py-24 text-center">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-400">
                    <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.6">
                        <rect x="3" y="6" width="18" height="12" rx="2" />
                        <path d="M3 10h18" />
                    </svg>
                </div>
                <div>
                    <p className="font-medium text-slate-700">No configurations yet</p>
                    <p className="text-sm text-slate-500">Add a country to set up its payment gateways.</p>
                </div>
            </div>
        );
    }

    const renderGatewayBadge = (enabled) => (
        <StatusBadge status={enabled ? "ENABLED" : "DISABLED"} />
    );

    return (
        <>
            <div className="overflow-x-auto rounded-2xl border border-slate-200">
                <table className="min-w-full divide-y divide-slate-200">
                    <thead className="bg-slate-50">
                        <tr>
                            <th className="px-6 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
                                Country
                            </th>

                            <th className="px-6 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
                                Code
                            </th>

                            <th className="px-6 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-slate-500">
                                Razorpay
                            </th>

                            <th className="px-6 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-slate-500">
                                Stripe
                            </th>

                            <th className="px-6 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-slate-500">
                                PayPal
                            </th>

                            <th className="px-6 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-slate-500">
                                Status
                            </th>

                            <th className="px-6 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-slate-500">
                                Actions
                            </th>
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-slate-100 bg-white">
                        {data.map((item) => (
                            <tr
                                key={item.id}
                                className="transition-colors hover:bg-slate-50/80"
                            >
                                <td className="px-6 py-4">
                                    <div className="flex items-center gap-3">
                                        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-xs font-bold text-emerald-700">
                                            {item.country_code}
                                        </div>
                                        <span className="font-medium text-slate-900">
                                            {item.country_name}
                                        </span>
                                    </div>
                                </td>

                                <td className="px-6 py-4">
                                    <span className="font-mono text-sm font-semibold text-slate-500">
                                        {item.country_code}
                                    </span>
                                </td>

                                <td className="px-6 py-4 text-center">
                                    {renderGatewayBadge(item.razorpay_enabled)}
                                </td>

                                <td className="px-6 py-4 text-center">
                                    {renderGatewayBadge(item.stripe_enabled)}
                                </td>

                                <td className="px-6 py-4 text-center">
                                    {renderGatewayBadge(item.paypal_enabled)}
                                </td>

                                <td className="px-6 py-4 text-center">
                                    <StatusBadge
                                        status={
                                            item.is_active
                                                ? "ACTIVE"
                                                : "INACTIVE"
                                        }
                                    />
                                </td>

                                <td className="px-6 py-4">
                                    <div className="flex justify-center gap-2">
                                        <button
                                            onClick={() => onEdit(item)}
                                            className="rounded-lg px-3 py-1.5 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900"
                                        >
                                            Edit
                                        </button>

                                        <button
                                            onClick={() => onDelete(item)}
                                            className="rounded-lg px-3 py-1.5 text-sm font-medium text-rose-600 transition-colors hover:bg-rose-50"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="mt-4">
                <ServerPagination
                    currentPage={pagination.current_page || 1}
                    totalPages={pagination.total_pages || 1}
                    totalCount={pagination.count || 0}
                    pageSize={pagination.page_size || 10}
                    onPageChange={onPageChange}
                />
            </div>
        </>
    );
};

export default CountryPaymentGatewayTable;